import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { parse, isValid } from 'date-fns'

const parseDateOfBilling = (value: string | undefined): Date | null => {
  if (!value || typeof value !== 'string') return null
  const parsed = parse(value.trim(), 'dd/MM/yyyy', new Date())
  return isValid(parsed) ? parsed : null
}

export type GetCompetencePeriod = () => { minDate?: Date; maxDate?: Date }

export const createAddEditOtherServicesModalSchema = (
  minDateOrGetter?: Date | GetCompetencePeriod,
  maxDate?: Date
) =>
  yupResolver(
    yup.object({
      clientName: yup.string().required('Cliente é obrigatório'),
      clientType: yup.string().required('Tipo de cliente é obrigatório'),
      dateOfBilling: yup
        .string()
        .required('Data é obrigatório')
        .test(
          'date-within-competence',
          'A data deve estar dentro do período da competência.',
          (value) => {
            if (!value) return true
            const date = parseDateOfBilling(value)
            if (!date) return false
            const minDate =
              typeof minDateOrGetter === 'function'
                ? minDateOrGetter().minDate
                : minDateOrGetter
            const max =
              typeof minDateOrGetter === 'function'
                ? minDateOrGetter().maxDate
                : maxDate
            if (minDate != null && date < minDate) return false
            if (max != null && date > max) return false
            return true
          }
        ),
      serviceDescription: yup.string().required('Descrição é obrigatória'),
      grossUnitValue: yup.string().required('Valor bruto unitário é obrigatório'),
      totalQuantity: yup
        .string()
        .required('Qtd total é obrigatório')
        .test('is-valid-number', 'Qtd. Total inválida', (value) => {
          if (!value) return false
          const number = Number(value)
          return !isNaN(number) && number > 0
        }),
      tax: yup.string().required('Imposto é obrigatório'),
      observations: yup.string().required('Observações é obrigatório')
    })
  )

/** @deprecated Use createAddEditOtherServicesModalSchema(minDate, maxDate) para validar período da competência. */
export const addEditOtherServicesModalSchema = createAddEditOtherServicesModalSchema()
